import { render } from "./firststepGrooming.vue?vue&type=template&id=b822d4ee&scoped=true"
import script from "./firststepGrooming.vue?vue&type=script&lang=js"
export * from "./firststepGrooming.vue?vue&type=script&lang=js"

import "./firststepGrooming.vue?vue&type=style&index=0&id=b822d4ee&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b822d4ee"]])

export default __exports__